import type { ReactNode } from 'react';
import './record-table.css';

/** A list of records: people, organizations, events, attendees. */
export function RecordTable({
  headings,
  children,
  className,
}: {
  headings: string[];
  children: ReactNode;
  className?: string;
}) {
  return (
    <table className={className ? `table record-table ${className}` : 'table record-table'}>
      <thead>
        <tr>
          {headings.map((h) => (
            <th key={h}>{h}</th>
          ))}
        </tr>
      </thead>
      <tbody>{children}</tbody>
    </table>
  );
}
